__webpack_require__.p = "https://static.spqr.app/7ced8781d2d5731aed567526004bb93cf901605f/_next/";